'use strict';

import "angular-paginate-anything";
import "angular-messages";
import "@flowjs/ng-flow";
import {Flow} from "../../lib/flowjs";
import "angular-ui-bootstrap";

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');
EwSiteApp.requires.push('flow');
EwSiteApp.requires.push('ngMessages');
EwSiteApp.requires.push('bgf.paginateAnything');

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
	return function (udate) {
		var format = 'yyyy-MM-dd';
		if (arguments[1]) {
			format = arguments[1];
		}
		return $filter('date')(udate * 1000, format);
	};
}]);

EwSiteApp.config(['uibDatepickerConfig', function (uibDatepickerConfig) {
	uibDatepickerConfig.showWeeks = false;
	uibDatepickerConfig.startingDay = 1;
	uibDatepickerConfig.formatDay = "d";
	uibDatepickerConfig.datepickerPopup = "yyyy-MM-dd";

}]);

EwSiteApp.controller('SkelbimaiCategoryCtrl', ["$scope", "$sce", "$filter", "$http", "$log", function($scope, $sce, $filter, $http, $log){

	$scope.dataUrl = skelbimaiData.dataUrl;
	$scope.itemsperpage = skelbimaiData.itemsperpage;
	$scope.types = skelbimaiData.types;
	$scope.startingPage = 0;
	$scope.reloadPage = false;
	$scope.loading = false;

	$scope.items = {
		list: []
	};

	function getDefaultParams(){
		return {
			title: '',
			type_id: ''
		};
	};
	$scope.filter = getDefaultParams();
	$scope.$on('pagination:loadStart', function (event, status, config) {
		$scope.loading = true;
	});

	$scope.$on('pagination:loadPage', function (event, status, config) {
		$scope.loading = false;
	});

	$scope.showClear = function(){
		return !($filter('json')($scope.filter) === $filter('json')(getDefaultParams()));
	};

	$scope.resetFilter = function(){
		$scope.filter = getDefaultParams();
	};

}]);

EwSiteApp.controller('SkelbimaiCtrl', ["$scope", "$sce", "$filter", "$http", "$log", "$uibModal", function ($scope, $sce, $filter, $http, $log, $uibModal) {
	$scope.datepickerOptions = {
		initDate: new Date(),
		shortcutPropagation: true
	};
	$scope.sumbitUrl = skelbimaiData.submitUrl;
	$scope.updateUrl = skelbimaiData.updateUrl;
	$scope.removeUrl = skelbimaiData.removeUrl;
//	$scope.cities = skelbimaiData.cities;
	$scope.categories = skelbimaiData.categories;
	$scope.types = skelbimaiData.types;
	$scope.photoid = [];

	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};

	$scope.date_from = {
		open: false,
		date: new Date()
	};

	$scope.date_to = {
		open: false,
		date: new Date().setDate(new Date().getDate() + 30)
	};

	$scope.sitekey = skelbimaiData.recaptcha.siteKey;

	$scope.submited = false;
	$scope.loading = false;
	$scope.message = '';
	$scope.errors = [];
	$scope.rules_accept = false;
	$scope.data = {
		title: '',
		description: '',
		category_id: '',
		email: '',
		phone: '',
		type_id: '',
		city: '',
		name: '',
		photoid: []
	};

	$scope.updateScope = function () {
		if (skelbimaiData.data) {
			if (typeof (skelbimaiData.data.title) !== 'undefined') {
				$scope.data.title = skelbimaiData.data.title;
			}
			if (typeof (skelbimaiData.data.description) !== 'undefined') {
				$scope.data.description = skelbimaiData.data.description;
			}
			if (typeof (skelbimaiData.data.category_id) !== 'undefined') {
				$scope.data.category_id = skelbimaiData.data.category_id;
			}
			if (typeof (skelbimaiData.data.email) !== 'undefined') {
				$scope.data.email = skelbimaiData.data.email;
			}
			if (typeof (skelbimaiData.data.phone) !== 'undefined') {
				$scope.data.phone = skelbimaiData.data.phone;
			}
			if (typeof (skelbimaiData.data.type_id) !== 'undefined') {
				$scope.data.type_id = skelbimaiData.data.type_id;
			}
			if (typeof (skelbimaiData.data.city) !== 'undefined') {
				$scope.data.city = skelbimaiData.data.city;
			}
			if (typeof (skelbimaiData.data.name) !== 'undefined') {
				$scope.data.name = skelbimaiData.data.name;
			}
			if (typeof (skelbimaiData.data.date_from) !== 'undefined') {
				$scope.date_from.date = new Date(skelbimaiData.data.date_from * 1000);
			}
			if (typeof (skelbimaiData.data.date_to) !== 'undefined') {
				$scope.date_to.date = new Date(skelbimaiData.data.date_to * 1000);
			}
			if (typeof (skelbimaiData.data.photoid) !== 'undefined' && Array.isArray(skelbimaiData.data.photoid)) {
				$scope.data.photoid = skelbimaiData.data.photoid;
				if (typeof (skelbimaiData.data.photos) !== 'undefined') {
					$scope.initfiles = skelbimaiData.data.photos;
				}
			}

		}
	};

	if (skelbimaiData.default_category_id) {
		$scope.data.category_id = skelbimaiData.default_category_id;
	}

	$scope.updateScope();
	$scope.recaptchaResponse = null;


	$scope.send = function () {
		if ($scope.isValid() && typeof grecaptcha !== 'undefined') {
			grecaptcha.ready(function () {
				if ($scope.sitekey) {
					$scope.loading = true;
					grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
						$scope.recaptchaResponse = token;
						$scope.submitForm();
					});
				} else {
					$scope.submited = true;
					console.log("no recaptcha siteKey");
				}
			});
		} else {
			$scope.loading = false;
			console.log("no recaptcha service");
		}
	};

	$scope.submitForm = function () {
		if ($scope.sumbitUrl !== '') {
			$scope.data.date_from = $filter('date')($scope.date_from.date, 'yyyy-MM-dd');
			$scope.data.date_to = $filter('date')($scope.date_to.date, 'yyyy-MM-dd');

			let post_data = $scope.data;

			if (typeof skelbimaiData.recaptcha !== 'undefined') {
				post_data[skelbimaiData.recaptcha.field] = $scope.recaptchaResponse;
			}
			$http({
				method: 'POST',
				url: $scope.sumbitUrl,
				data: post_data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.message = $scope.explicitlyTrustedHtml(skelbimaiData.text_after_submit);
					$scope.submited = true;
				} else if (angular.isDefined(response.data.messages)) {
					$scope.errors = response.data.messages;
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}).then(function () {
//				$scope.submited = true;
				$scope.loading = false;
			});
		}
	};

	$scope.update = function () {
		if ($scope.isValid() && typeof grecaptcha !== 'undefined') {
			grecaptcha.ready(function () {
				if ($scope.sitekey) {
					$scope.loading = true;
					grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
						$scope.recaptchaResponse = token;
						$scope.updateForm();
					});
				} else {
					$scope.submited = true;
					console.log("no recaptcha siteKey");
				}
			});
		} else {
			$scope.loading = false;
			console.log("no recaptcha service");
		}
	};

	$scope.updateForm = function () {
		if ($scope.updateUrl !== '') {
			$scope.data.date_from = $filter('date')($scope.date_from.date, 'yyyy-MM-dd');
			$scope.data.date_to = $filter('date')($scope.date_to.date, 'yyyy-MM-dd');

			let post_data = $scope.data;
			if (typeof skelbimaiData.recaptcha !== 'undefined') {
				post_data[skelbimaiData.recaptcha.field] = $scope.recaptchaResponse;
			}
			$http({
				method: 'POST',
				url: $scope.updateUrl,
				data: post_data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					location.reload();
				} else if (angular.isDefined(response.data.messages)) {
					$scope.errors = response.data.messages;
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}).then(function () {
//				$scope.submited = true;
				$scope.loading = false;
			});
		}
	};

	$scope.removeItem = function (entry) {
		var modalInstance = $uibModal.open({
			templateUrl: 'skelbimai/skelbimas_remove.html',
			controller: skelbimasRemoveCtrl,
			//size: size,
			resolve: {
				item: function () {
					return entry;
				}
			}
		});
		modalInstance.result.then(function (result) {
			if ($scope.removeUrl !== '') {
				$http({
					method: 'GET',
					url: $scope.removeUrl
				}).then(function (response) {
					if (response.data.success) {
						location.reload();
					} else {
//						$log.error(response.data.data.message);
						$scope.ewMessages.add(response.data.message);
					}
					if (response.data.debug) {
						$log.debug(response.data.debug);
					}
				});
			}
		}, function () {});
	};

	function skelbimasRemoveCtrl($scope, $uibModalInstance, item) {
		$scope.item = angular.copy(item);
		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

//		$scope.callAction = function (action) {
//			$uibModalInstance.close({action: action});
//		};
//
//		$scope.close = function () {
//			$uibModalInstance.dismiss('cancel');
//		};
	}

	$scope.isValid = function () {
		if ($scope.rules_accept === false) {
			return false;
		}
		return true;
	};

	$scope.hasErrors = function () {
		return $scope.errors.length > 0;
	};
}]);


EwSiteApp.directive('numberonly', function () {
	return {
		require: 'ngModel',
		restrict: 'A',
		link: function (scope, element, attrs, ctrl) {
			ctrl.$parsers.push(function (input) {
				if (input == undefined)
					return '';
				var inputNumber = input.toString().replace(/[^0-9]/g, '');
				if (inputNumber != input) {
					ctrl.$setViewValue(inputNumber);
					ctrl.$render();
				}
				return inputNumber;
			});
		}
	};
});



function getJsCookieValue(a) {
	var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}

//function modalRejectHandler(result){
//	console.log(result);
//}

EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
		singleFile: false,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true
	};
	// Apejimas https://lightrun.com/answers/flowjs-ng-flow-unable-to-initialize-module-using-browserify
	//	https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};
	// Add XSRF header to upload requests
	if (typeof (secure_xsrf_name) != 'undefined') {
		var xsrf_token = getJsCookieValue(secure_xsrf_name);
		if (xsrf_token !== '') {
			flowFactoryProvider.defaults.headers = {};
			flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
		}
	}
	flowFactoryProvider.on('fileSuccess', function (file, response) {
		eval("var d = " + response);
		if (d) {
			file.response = d;
		}
	});
//	flowFactoryProvider.on('catchAll', function (event) {
//	 console.log('catchAll', arguments);
//	 });

//	 flowFactoryProvider.on('fileAdded', function (event) {
//	 console.log(event);
//	 });
		// Can be used with different implementations of Flow.js
		// flowFactoryProvider.factory = fustyFlowFactory;
	}]);

EwSiteApp.controller('MultiFile', ["$scope", "$attrs", "$filter", function ($scope, $attrs, $filter) {
//$controller('SingleFile', {$scope: $scope, $attrs: $attrs});
//	$scope = angular.extend($scope, $scope.$eval($attrs.startOptions));
	$scope.saveids = [];
	$scope.transmitToParent = function () {
		if (typeof ($scope.$parent.data.photoid) != 'undefined') {
			$scope.$parent.data.photoid = $scope.saveids;
		}
	};

	if (typeof ($scope.$parent.data.photoid) != 'undefined') {
		$scope.saveids = $scope.$parent.data.photoid;
		$scope.transmitToParent();
	}
	$scope.$on('flow::fileSuccess', function (event, $flow, flowFile) {
		$scope.saveids.push(flowFile.response.fileId);
		$scope.showdelete = true;
		$scope.transmitToParent();
	});

	$scope.remove = function (file) {
		file.cancel();
		var indx = $scope.saveids.indexOf(file.response.fileId);
		if (indx > -1) {
			$scope.saveids.splice(indx, 1);
		}

//		$scope.saveids.push(flowFile.response.fileId);
//		$scope.showdelete = true;
		$scope.transmitToParent();
	};

	$scope.removeInitFile = function (file) {
		$scope.$parent.initfiles = $filter('filter')($scope.$parent.initfiles, {id: '!' + file.id}, true);
		var indx = $scope.saveids.indexOf(file.id);
		if (indx > -1) {
			$scope.saveids.splice(indx, 1);
		}
//		$scope.saveids.push(flowFile.response.fileId);
//		$scope.showdelete = true;
		$scope.transmitToParent();
	};
	$scope.delete = function ($flow) {
		if ($flow.files.length > 0) {
			$flow.cancel();
		}
		$scope.initfilename = null;
		$scope.saveids = [];
		$scope.showdelete = false;
		$scope.transmitToParent();


	};
//	$scope.showdelete = ($scope.saveid > 0);
}]);

EwSiteApp.directive('popupSelect', ["$timeout", function ($timeout) {
	return {
		restrict: 'A',
		scope: {
			ngModel: '='
		},
		link: function (scope, element, attr) {
			$(element).select2({
				"minimumResultsForSearch": -1
			});
//            $(element).select2();
			scope.$watch(function () {
				return scope.ngModel;
			}, function () {
				$timeout(function () {
					$(element).trigger('change');
				}, 20);
			});
		}
	};
}]);
